export const constants = {
    'apiUrl': 'https://backend.supremeinternationals.com'
    // 'apiUrl': 'http://localhost:8080'
    };
    